import { StackView, Icon, Text } from '@planningcenter/tapestry-react';
import React from 'react';

const LoadingErrorIndicator = () => (React.createElement(StackView, { alignment: "center", spacing: 2, padding: 2, paddingTop: "10%" },
    React.createElement(Icon, { name: "general.exclamationTriangle", color: "warning", size: "xl" }),
    React.createElement(Text, { color: "foregroundSecondary", align: "center" }, "An error occured while connecting to the chat, please try again.")));

export { LoadingErrorIndicator };
//# sourceMappingURL=loading_error_indicator.js.map
